import { isMobileOnly } from "react-device-detect";

export function isValidArray(arr) {
  return Boolean(arr && arr.length > 0);
}
export const getImage = (
  meta,
  type,
  // any = false,
  key,
  keyName
  // isMobile = true,
) => {
  if (!key || !isValidArray(meta)) {
    return "";
  }
  return meta.find((x) => x[keyName]?.includes(key))
    ? meta.find((x) => x[keyName]?.includes(key)).url
    : "";
};
export const getImageUrl = (meta, key, keyName = "key") => {
  const device = isMobileOnly ? "App" : "Web";
  if (!key || !isValidArray(meta)) {
    return "";
  }
  const imageItem = meta.find(
    (item) => item?.[keyName]?.includes(key) && item?.[keyName]?.includes(device)
  );
  return imageItem ? imageItem.url : "";
};
export const getMetaValue = (meta, key = "", keyName = "key") => {
  if (!key || !isValidArray(meta)) {
    return "";
  }
  return meta.find((x) => x[keyName]?.includes(key))
    ? meta.find((x) => x[keyName]?.includes(key)).value
    : "";
};

const youtube_watch_regex = /^https:\/\/www\.youtube\.com\/watch\?v=.+$/;
export const isValidYoutubeUrl = (url) => youtube_watch_regex.test(url);

export function isValidNumber(n) {
  return !isNaN(n) || Boolean(n) || Number(n) <= 0;
}
